import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../../Assets/logo.png";

function Home2() {
  const introBlockRef = useRef(null);
  const serviceBlockRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1, // 10%만 보이면 바로 시작
      rootMargin: "0px 0px -20px 0px", // 거의 바로 트리거
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("Adding animate-in to:", entry.target.className);
          entry.target.classList.add("animate-in");
        } else {
          console.log("Removing animate-in from:", entry.target.className);
          // 위로 스크롤하면 다시 사라지기
          entry.target.classList.remove("animate-in");
        }
      });
    }, observerOptions);

    if (introBlockRef.current) {
      observer.observe(introBlockRef.current);
    }
    if (serviceBlockRef.current) {
      observer.observe(serviceBlockRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Container fluid className="home2-section" id="about">
      <Container>
        {/* 첫 번째 블록: 로고부터 회사 소개까지 */}
        <div ref={introBlockRef} className="home2-intro-block scroll-animate">
          {/* 로고 섹션 */}
          <Row>
            <Col md={12} className="home2-logo-section">
              <img src={logo} alt="동진에어텍 로고" className="home2-logo" />
            </Col>
          </Row>

          {/* 회사 소개 섹션 */}
          <Row>
            <Col md={12} className="home2-company-intro">
              <p className="home2-intro-text">
                동진에어텍은 귀뚜라미범양냉방 공식 전문점으로,{" "}
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <strong>산업현장의 냉·난방 및 공조 설비 유지보수</strong>를
                <br className="mobile-br" /> 전문으로 하는 기업입니다.
                <br className="mobile-br" />
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                <br className="desktop-br"></br>
                <br className="large-br"></br>
                <br className="large-br"></br>
                특히 발전소 및 대형 플랜트의 정기점검, 긴급복구,{" "}
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                효율개선 프로젝트에 이르기까지 <br className="mobile-br" />
                <br className="desktop-br"></br>
                <strong>폭넓은 기술지원과 안정적인 서비스를 통해</strong>{" "}
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <strong>고객의 만족과 신뢰를 쌓아왔습니다.</strong>
                <br className="mobile-br" />
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                <br className="desktop-br"></br>
                <br className="large-br"></br>
                <br className="large-br"></br>
                동진에어텍은 여기에 안주하지 않고, <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                <strong>
                  디지털 기반의 유지관리 시스템, <br className="mobile-br" />
                  친환경 설비 대응, 에너지 절감 기술 등
                </strong>{" "}
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                미래 환경 변화에도 발맞춰 나아가고자 합니다.
                <br className="mobile-br" />
                <br className="mobile-br" />
                <br className="tablet-br"></br>
                <br className="tablet-br"></br>
                <br className="desktop-br"></br>
                <br className="desktop-br"></br>
                <br className="large-br"></br>
                <br className="large-br"></br>
                고객 여러분의 소중한 설비가 <br className="mobile-br" />
                최상의 효율을 발휘할 수 있도록 <br className="mobile-br" />
                <br className="tablet-br"></br>
                <strong>끝까지 책임지는 파트너가 되겠습니다.</strong>
              </p>
            </Col>
          </Row>
        </div>

        {/* 두 번째 블록: 서비스 소개 */}
        <div
          ref={serviceBlockRef}
          className="home2-service-block scroll-animate"
        >
          {/* 서비스 소개 제목 */}
          <Row>
            <Col md={12} className="home2-service-title-section">
              <h2 className="home2-service-title">서비스 소개</h2>
            </Col>
          </Row>

          {/* 서비스 카드들 */}
          <Row className="home2-services-row">
            <Col
              xxl={3}
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              className="home2-service-col"
            >
              <div className="home2-service-card">
                <h3 className="home2-service-card-title">정기 점검</h3>
                <ul className="home2-service-list">
                  <li>공조 장비 운전상태 점검</li>
                  <li>냉/난방기 가동 사이클 점검</li>
                  <li>전기/전자 회로 안정성 점검</li>
                  <li>점검결과 리포트 제공</li>
                </ul>
              </div>
            </Col>

            <Col
              xxl={3}
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              className="home2-service-col"
            >
              <div className="home2-service-card">
                <h3 className="home2-service-card-title">긴급출동 서비스</h3>
                <ul className="home2-service-list">
                  <li>24시간 긴급 대응</li>
                  <li>주요 발전소 및 상업시설 경험 보유</li>
                  <li>엔지니어 현장 출동</li>
                </ul>
              </div>
            </Col>

            <Col
              xxl={3}
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              className="home2-service-col"
            >
              <div className="home2-service-card">
                <h3 className="home2-service-card-title">설치 및 리뉴얼</h3>
                <ul className="home2-service-list">
                  <li>신규 상업시설, 공장, 오피스 등</li>
                  <li>EHP, 직팽식 공조기, 냉동기 등</li>
                  <li>배관 공사 및 자동제어 연동</li>
                  <li>냉/난방, 냉장/냉동 설계 및 시공</li>
                </ul>
              </div>
            </Col>

            <Col
              xxl={3}
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              className="home2-service-col"
            >
              <div className="home2-service-card">
                <h3 className="home2-service-card-title">에너지 효율 진단</h3>
                <ul className="home2-service-list">
                  <li>운전 패턴 분석</li>
                  <li>고효율 장비 제안</li>
                  <li>운전시간 최적화 컨설팅</li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
}

export default Home2;
